export const VENUE_BUTTONS_SHADOW_VALUE = '0 0 4px rgba(0, 0, 0, .85)';
